(() => {

  class RCToastContainer extends HTMLElement {

    constructor(){
      super();
      this._toasts = [];
      this._maxToasts = 4;
      this._settings = null;
    };

    connectedCallback(){
      this._settings = (window.umbrellaConfig && window.umbrellaConfig.toast_settings) || {};
      const placement = this._settings.placement || 'bottom_right';
      const base = ['fixed','z-[9999]','flex','flex-col','gap-2'];
      const map = {
        top_right: ['top-4','right-4'],
        top_center: ['top-4','left-1/2','-translate-x-1/2'],
        bottom_right: ['bottom-4','right-4'],
        bottom_center: ['bottom-4','left-1/2','-translate-x-1/2'],
        bottom_left: ['bottom-4','left-4']
      };
      const classes = [...base, ...(map[placement] || map.bottom_right)];
      this.classList.add(...classes);
      this._maxToasts = typeof this._settings.maxCount === 'number' ? this._settings.maxCount : 4;
      this.setAttribute('aria-live','polite');
      this.setAttribute('role','status');
    };

    show(opts = {}){
      if(this._settings && this._settings.enabled === false) return null;
      const defaultTime = (this._settings && typeof this._settings.durationMs === 'number') ? this._settings.durationMs : 4000;
      const { message = '', type = 'info', dismissable = true, time = defaultTime, devMessage } = opts;
      if(!message) return;
      // Cap concurrent toasts
      if(this._toasts.length >= this._maxToasts){
        const oldest = this._toasts.shift();
        if(oldest) oldest.remove();
      };
      const toast = document.createElement('rc-toast');
      if(devMessage) toast.__devMessage = devMessage;
      const styleConfig = {
        paddingPx: this._settings?.paddingPx,
        radiusPx: this._settings?.radiusPx,
        bgColor: this._settings?.colors?.[type]?.bg,
        textColor: this._settings?.colors?.[type]?.text
      };
      // If rc-toast is not yet defined, delay configuration a tick
      customElements.get('rc-toast')
        ? toast.configure({ message, type, dismissable, time, devMessage, styleConfig })
        : setTimeout(() => toast.configure && toast.configure({ message, type, dismissable, time, devMessage, styleConfig }), 0);
      this.appendChild(toast);
      this._toasts.push(toast);
      toast.addEventListener('DOMNodeRemoved', () => {
        const idx = this._toasts.indexOf(toast);
        if(idx > -1) this._toasts.splice(idx,1);
      });
      return toast;
    };

    showToast(message, type = 'info', dismissable = true, time = 4000){
      return this.show({ message, type, dismissable, time });
    };

  };

  if(!customElements.get('rc-toast-container')){
    customElements.define('rc-toast-container', RCToastContainer);
  };

  function getContainer(){
    const settings = (window.umbrellaConfig && window.umbrellaConfig.toast_settings) || {};
    if(settings.enabled === false){ return null; }
    let el = document.querySelector('rc-toast-container');
    if(!el){ el = document.createElement('rc-toast-container'); document.body.appendChild(el); }
    return el;
  };

  function _showToast(message, type = 'info', dismissable = true, time = 4000){
    const container = getContainer();
    if(!container) return null;
    return container.showToast(message, type, dismissable, time);
  };

  function _bindCartEventToasts(){
    const events = (window.umbrellaConfig && window.umbrellaConfig.events) || {};
    const messages = (window.umbrellaConfig && window.umbrellaConfig.toast_settings && window.umbrellaConfig.toast_settings.messages) || {};

    // The "Added to cart" popup replaces the add toast when it's enabled.
    const atcPopup = !!(window.umbrellaConfig && window.umbrellaConfig.atcPopup);
    const cartToastMap = [
      { event: atcPopup ? null : events.cartAdded, message: messages.cartAdded || 'Item added to cart.', type: 'success' },
      { event: events.cartItemUpdated, message: messages.cartUpdated || 'Cart updated.', type: 'success' },
      { event: events.cartItemRemoved, message: messages.cartRemoved || 'Item removed from cart.', type: 'info' },
      { event: events.cartCleared, message: messages.cartCleared || 'Cart cleared.', type: 'info' }
    ];

    cartToastMap.forEach(({ event, message, type }) => {
      if(event) document.addEventListener(event, () => { _showToast(message, type); });
    });
  };
  
  // Attach to umbrellaConfig and keep global alias for compatibility
  if(!window.umbrellaConfig) window.umbrellaConfig = {};
  window.umbrellaConfig.showToast = _showToast;
  window.showToast = _showToast;

  window.rcToast = { show(opts){ const c = getContainer(); return c ? c.show(opts) : null; }, container(){ return getContainer(); } };

  _bindCartEventToasts();

})();